<template>
  <div>
    <div v-if="!isPrint">
      <el-button type="primary" style="margin-bottom:5px" @click="printPage">打印</el-button>
    </div>
    <div id="printContent">
      <table class="table">
        <tr>
          <td style="width:120px">合同号:</td>
          <td>DN106458 W69295HJ4514</td>
        </tr>
        <tr>
          <td style="width:120px">订单号:</td>
          <td>PC946663</td>
        </tr>
        <tr>
          <td style="width:120px">项目名称:</td>
          <td>华星T9项目</td>
        </tr>
        <tr>
          <td style="width:120px">包装尺寸:</td>
          <td>2100*1000*700</td>
        </tr>
        <tr>
          <td style="width:120px">重量:</td>
          <td>150KG</td>
        </tr>
        <tr>
          <td style="width:120px">装箱内容:</td>
          <td>控制柜</td>
        </tr>
        <tr>
          <td style="width:120px">箱号:</td>
          <td>1</td>
        </tr>
        <tr>
          <td style="width:120px">规格型号:</td>
          <td>1</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isPrint:false,
      };
    },
    methods:{
      printPage() {
        this.isPrint = true;
        this.$nextTick(()=>{
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
          return false;
        });
       
      },
    },
  };
</script>

<style lang="scss" scoped>
.table{
  margin: 0;
  width: 500px;
  border-collapse: collapse;
}
.table td{
  border: 1px solid #333;
  margin: 0;
  padding: 10px;
}
</style>